<div class="text-center not-found">
  <h1>404 Not found</h1>
  <p>
    Back to
    <a routerLink="/dashboard">Dashboard/Login</a>
  </p>
</div>
